<template>
  <div id="nav" :class="{ lightNav: !isDarkMode, darkNav: isDarkMode }">
    <div class="nav-1">
      <img
        class="navLogo"
        src="@/assets/wolf-darkMode.svg"
        alt="wolf logo"
        v-show="isDarkMode"
      />
      <img
        class="navLogo"
        src="@/assets/wolf-lightMode.svg"
        alt="wolf logo"
        v-show="!isDarkMode"
      />
      <router-link
        to="/"
        :class="{ lightNav: !isDarkMode, darkNav: isDarkMode }"
        >Home</router-link
      >
      <router-link
        to="/manage"
        :class="{ lightNav: !isDarkMode, darkNav: isDarkMode }"
        >Manage users
      </router-link>
      <router-link
        to="/team"
        :class="{ lightNav: !isDarkMode, darkNav: isDarkMode }"
        >Team</router-link
      >
    </div>
    <a @click="onClick">Logout<img src="@/assets/logout.svg" alt="logout"/></a>
  </div>
</template>

<script>
import { auth } from "@/main";

export default {
  name: "Header",
  computed: {
    isDarkMode() {
      return this.$store.getters.isDarkMode;
    }
  },
  methods: {
    onClick() {
      const user = auth.currentUser();
      user
        .logout()
        .then(() => {
          this.$router.push({
            name: "signin",
            params: { userLoggedOut: true }
          });
        })
        .catch(error => {
          alert("Error: " + error);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.lightNav {
  background: $white;
}

.darkNav {
  background: $superDarkBackground;
}

.navLogo {
  height: 50px;
  margin-right: 25px;
}

#nav {
  padding: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  box-sizing: border-box;
  box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  padding: 20px 10%;

  a {
    font-weight: bold;
    color: $darkGray;

    &.router-link-exact-active.darkNav {
      color: $white;
    }
    &.router-link-exact-active.lightNav {
      color: $black;
    }
  }
}

.nav-1 {
  display: flex;
  align-items: center;

  a {
    margin-left: 20px;
    margin-right: 20px;
  }
}
</style>
